import moment from 'moment';
import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'Reels',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (this.loginDetails) {
            if (![1, 2, 3, 4, 5].includes(this.loginDetails.userType))
                this.logout();
        } else {
            this.logout();
        }

        this.GetInfo(this.pageNo);
    },

    filters: {
        moment: function (date) {
            if (date === null) return "فارغ";
            return moment(date).format('DD/MM/YYYY');
        },
        momentTime: function (date) {
            if (date === null) return "فارغ";
            return moment(date).format('DD/MM/YYYY || HH:MM');
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            StatusFilter: 0,
            ScreenTitle: 'ريلز واكب',
            Info: [],
            Statistics: {},
            RejectReason: ''
        };
    },

    methods: {
        GetInfo(pageNo) {
            if (typeof pageNo === 'number' && pageNo > 0) {
                this.pageNo = pageNo;
            } else if (!pageNo) {
                this.pageNo = 1;
            }
            if (!this.Search)
                this.$blockUI.Start();

            this.$http.GetReels(this.pageNo, this.pageSize, this.Search, this.StatusFilter)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                    this.Statistics = response.data.statistics || {};
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        StatusLabel(status) {
            if (status === 1) return 'منشور';
            if (status === 2) return 'قيد المراجعة';
            if (status === 3) return 'مرفوض';
            return 'غير معروف';
        },

        Approve(id) {
            Swal.fire({
                title: 'تأكيد الموافقة',
                text: 'هل تريد الموافقة على هذا الريل ونشره؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'موافقة',
                showCancelButton: true,
                cancelButtonText: 'إلغاء'
            }).then((result) => {
                if (!result.isConfirmed) return;

                this.$blockUI.Start();
                this.$http.ApproveReel(id)
                    .then((response) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        this.StatusFilter = 1;
                        this.pageNo = 1;
                        this.GetInfo(1);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'حدث خطأ غير متوقع');
                    });
            });
        },

        Reject(id) {
            Swal.fire({
                title: 'رفض الريل',
                input: 'textarea',
                inputLabel: 'سبب الرفض (اختياري)',
                inputPlaceholder: 'اكتب سبب الرفض...',
                icon: 'warning',
                customClass: { confirmButton: 'btn btn-danger' },
                buttonsStyling: false,
                confirmButtonText: 'رفض',
                showCancelButton: true,
                cancelButtonText: 'إلغاء'
            }).then((result) => {
                if (!result.isConfirmed) return;

                this.$blockUI.Start();
                this.$http.RejectReel(id, { Reason: result.value || '' })
                    .then((response) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        this.StatusFilter = 3;
                        this.pageNo = 1;
                        this.GetInfo(1);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'حدث خطأ غير متوقع');
                    });
            });
        },

        Delete(id) {
            Swal.fire({
                title: 'تأكيد الحذف',
                text: 'هل تريد حذف هذا الريل؟',
                icon: 'warning',
                customClass: { confirmButton: 'btn btn-danger' },
                buttonsStyling: false,
                confirmButtonText: 'حذف',
                showCancelButton: true,
                cancelButtonText: 'إلغاء'
            }).then((result) => {
                if (!result.isConfirmed) return;

                this.$blockUI.Start();
                this.$http.DeleteReel(id)
                    .then((response) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        this.GetInfo(this.pageNo);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'حدث خطأ غير متوقع');
                    });
            });
        }
    }
};
